import SEO from '@/components/shared/SEO'
import KeyInformation from '@/components/KeyInformation'
import USPBanner from '@/components/USPBanner'
import EgenticHero from '@/components/EgenticHero'
import ClaimScenarios from '@/components/ClaimScenarios'
import MisSoldSection from '@/components/MisSoldSection'

const EgenticPage = () => {
  return (
    <div className="flex-1">
      <SEO
        title="Egentic - Claims1 | Car Finance Claims UK"
        description="Join the Claims1 referral program and help others claim compensation for mis-sold car finance while earning rewards."
        keywords="referral program, Claims1, car finance claims, refer a friend, rewards"
        url="/egentic"
        image="/Image/Car-photo-illustration-claims1.webp"
        imageAlt="Claims1 Egentic Program"
        schemaType="WebPage"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Egentic', url: '/egentic' },
        ]}
      />

      <USPBanner />

      <EgenticHero />

      <ClaimScenarios compact />

      <MisSoldSection
        title={
          <>
            <div className="mb-2 text-base font-semibold sm:text-lg">
              DON&apos;T WORRY
            </div>
            CAN&apos;T REMEMBER IF YOU HAD{' '}
            <span style={{ color: 'rgb(255, 145, 77)' }}>CAR FINANCE?</span>
          </>
        }
        imageSrc="/Image/egentic-image-6.webp"
        description={
          <ul className="mx-auto inline-block space-y-3 sm:mx-0">
            <li className="flex items-start gap-3">
              <svg
                className="h-6 w-6 flex-shrink-0 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10" strokeWidth={2} />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 9l-6 6M9 9l6 6"
                />
              </svg>
              <span>Can&apos;t remember if you had any car finance</span>
            </li>
            <li className="flex items-start gap-3">
              <svg
                className="h-6 w-6 flex-shrink-0 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10" strokeWidth={2} />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 9l-6 6M9 9l6 6"
                />
              </svg>
              <span>Don&apos;t know your registration number</span>
            </li>
            <li className="flex items-start gap-3">
              <svg
                className="h-6 w-6 flex-shrink-0 text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10" strokeWidth={2} />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 9l-6 6M9 9l6 6"
                />
              </svg>
              <span>Can&apos;t find your finance paperwork</span>
            </li>
          </ul>
        }
        mobileTextFirst={true}
      />

      <MisSoldSection
        title={
          <>
            <div className="mb-2 text-base font-semibold sm:text-lg">
              NO PROBLEM
            </div>
            <span style={{ color: 'rgb(255, 145, 77)' }}>
              WE WILL FIND IT FOR YOU!
            </span>
          </>
        }
        description="Our expert team uses secure checks to trace your car finance history between 2007–2024. No documents, no reg number, no paperwork required."
        imageSrc="/Image/egentic-image-4.jpg"
        backgroundColor="#002020"
        textColor="white"
        imagePosition="left"
        mobileTextFirst={true}
        showCTA={true}
        ctaText="START YOUR CLAIM NOW"
      />

      <MisSoldSection
        title={
          <>
            DON&apos;T LEAVE{' '}
            <span style={{ color: '#ff914d' }}>YOUR MONEY BEHIND</span>
          </>
        }
        description={
          <>
            <p className="mb-4">
              Millions of UK drivers are owed refunds from 2007-2024. Yours
              could be waiting.
            </p>
            <ul className="mx-auto inline-block space-y-2 sm:mx-0">
              <li className="flex items-start gap-2">
                <svg
                  className="h-6 w-6 flex-shrink-0"
                  fill="#ff914d"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path
                    fill="white"
                    d="M9 12l2 2 4-4"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Claim in 60 seconds</span>
              </li>
              <li className="flex items-start gap-2">
                <svg
                  className="h-6 w-6 flex-shrink-0"
                  fill="#ff914d"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path
                    fill="white"
                    d="M9 12l2 2 4-4"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>
                  No Win No Fee
                  <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>
                    3
                  </sup>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <svg
                  className="h-6 w-6 flex-shrink-0"
                  fill="#ff914d"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path
                    fill="white"
                    d="M9 12l2 2 4-4"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>
                  On average £2,086 per household
                  <sup style={{ fontSize: '0.7em', verticalAlign: 'super' }}>
                    1
                  </sup>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <svg
                  className="h-6 w-6 flex-shrink-0"
                  fill="#ff914d"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path
                    fill="white"
                    d="M9 12l2 2 4-4"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>FCA regulated</span>
              </li>
            </ul>
          </>
        }
        imageSrc="/Image/egentic-image-3.jpg"
        mobileTextFirst={true}
        showCTA={true}
        ctaText="START YOUR CLAIM NOW"
      />

      <KeyInformation />
    </div>
  )
}

export default EgenticPage
